import { APP_PDC_URL } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const quaterConstants = {
  SET_QUATER_START: "SET_QUATER_START",
  SET_QUATER_SUCCESS: "SET_QUATER_SUCCESS",
  SET_QUATER_ERROR: "SET_QUATER_ERROR"
};

export function setQuater(
  auth,
  documentId,
  quater,
  itemCf,
  itemId,
  accountantCf,
  accountantId
) {
  return dispatch => {
    return new Promise(function(resolve, reject) {
      let request = {
        method: "PATCH",
        url: APP_PDC_URL + "/v2/documents/" + documentId + "/quater",
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: { quater, itemId, accountantId }
      };

      dispatch({
        type: quaterConstants.SET_QUATER_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: quaterConstants.SET_QUATER_SUCCESS,
            payload: { ...result.data, quater: quater }
          });
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: quaterConstants.SET_QUATER_ERROR,
            payload: { message: "Si è verificato un errore: " + response }
          });
          reject(response);
        });
    });
  };
}
